import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Related schemas declare no pcsLogicalCardUsage field, so every inverse is null.
const PcsLogicalCardUsageSchema = withDefaults({
  type: 'pcs-logical-card-usage',
  fields: [
    { kind: 'attribute', name: 'decisioning' },
    { kind: 'attribute', name: 'deletedAt' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsAuthorizations',
      type: 'pcs-authorization',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsTransactions',
      type: 'pcs-transaction',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'pcsNetworkMerchants',
      type: 'pcs-network-merchant',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'tasAssistances',
      type: 'tas-assistance',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsLogicalCardUsageSchema;
